import { RenewVisaHistoryDetailPage } from "@/features/renew-visa/pages/RenewVisaHistoryDetail";

const RenewVisaHistoryDetail = () => {
  return <RenewVisaHistoryDetailPage />;
};

export default RenewVisaHistoryDetail;
